<template>
  <div>
    <v-row no-gutters class="pt-2">
      <v-col cols="12" lg="6" class="dashboard__last-updated mb-2">
        INFORMACIÓN PERSONAL
      </v-col>
      <v-col cols="12" class="d-flex align-center">
        <v-avatar class="ma-3 mt-0 mb-4" color="primary">
          <v-icon dark> person</v-icon>
        </v-avatar>
        <div class="text-left ml-2 full-width-content">
          <p class="ma-0">Nombre</p>
          <v-divider class="mb-2 mt-2 accent divider-field"></v-divider>
          <v-text-field
            :disabled="editEnabled"
            full-width
            v-bind="form.name.props"
            v-model="form.name.value"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" class="d-flex align-center">
        <v-avatar class="ma-3 mt-0 mb-4" color="primary">
          <v-icon dark> phone</v-icon>
        </v-avatar>
        <div class="text-left ml-2 full-width-content">
          <p class="ma-0">Teléfono y ext</p>
          <v-divider class="mb-2 mt-2 accent divider-field"></v-divider>
          <v-text-field
            :disabled="editEnabled"
            full-width
            v-bind="form.phone.props"
            v-model="form.phone.value"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" class="d-flex align-center">
        <v-avatar class="ma-3 mt-0 mb-4" color="primary">
          <v-icon dark> chat_bubble</v-icon>
        </v-avatar>
        <div class="text-left ml-2 full-width-content">
          <p class="ma-0">Whatsapp</p>
          <v-divider class="mb-2 mt-2 accent divider-field"></v-divider>
          <v-text-field
            :disabled="editEnabled"
            full-width
            v-bind="form.whatsapp.props"
            v-model="form.whatsapp.value"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" class="d-flex align-center">
        <v-avatar class="ma-3 mt-0 mb-4" color="primary">
          <v-icon dark> business</v-icon>
        </v-avatar>
        <div class="text-left ml-2 full-width-content">
          <p class="ma-0">Puesto</p>
          <v-divider class="mb-2 mt-2 accent divider-field"></v-divider>
          <v-text-field
            :disabled="editEnabled"
            full-width
            v-bind="form.jobPosition.props"
            v-model="form.jobPosition.value"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12" class="d-flex align-center">
        <v-avatar class="ma-3 mt-0 mb-4" color="primary">
          <v-icon dark>room</v-icon>
        </v-avatar>
        <div class="text-left ml-2 full-width-content">
          <p class="ma-0">Sucursal</p>
          <v-divider class="mb-2 mt-2 accent divider-field"></v-divider>
          <v-select
            :disabled="editEnabled"
            :items="branchs"
            v-bind="form.branch.props"
            item-text="title"
            item-value="value"
            v-model="form.branch.value"
          ></v-select>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-divider></v-divider>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6" class="dashboard__last-updated">
        CREDENCIALES
      </v-col>
      <v-col cols="12" class="d-flex align-center">
        <v-avatar class="ma-3 mt-0 mb-4" color="primary">
          <v-icon dark> vpn_key</v-icon>
        </v-avatar>
        <div class="text-left ml-2 full-width-content">
          <v-text-field
            full-width
            v-if="!isEdit"
            v-bind="form.email.props"
            v-model="form.email.value"
          ></v-text-field>
          <template v-if="!isEdit">
            <v-text-field
              full-width
              :append-icon="showPasswd ? 'visibility' : 'visibility_off'"
              :type="showPasswd ? 'text' : 'password'"
              v-bind="form.password.props"
              @click:append="showPasswd = !showPasswd"
              v-model="form.password.value"
            ></v-text-field>
            <v-text-field
              full-width
              :append-icon="showPasswd ? 'visibility' : 'visibility_off'"
              :type="showPasswd ? 'text' : 'password'"
              @click:append="showPasswd = !showPasswd"
              v-bind="form.verifyPassword.props"
              v-model="form.verifyPassword.value"
            ></v-text-field>
          </template>
          <template v-else>
            <p class="caption">Contraseña con minimo 8 caracteres*</p>
            <v-text-field
              full-width
              :disabled="editEnabled"
              :append-icon="showPasswd ? 'visibility' : 'visibility_off'"
              :type="showPasswd ? 'text' : 'password'"
              v-bind="form.passwordEdit.props"
              @click:append="showPasswd = !showPasswd"
              v-model="form.passwordEdit.value"
            ></v-text-field>
            <v-text-field
              full-width
              :disabled="editEnabled"
              :append-icon="showPasswd ? 'visibility' : 'visibility_off'"
              :type="showPasswd ? 'text' : 'password'"
              @click:append="showPasswd = !showPasswd"
              v-bind="form.verifyPasswordEdit.props"
              v-model="form.verifyPasswordEdit.value"
            ></v-text-field>
          </template>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import User from "@/models/user";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      form: User.getRegisterForm(),
      showPasswd: false
    };
  },
  computed: {
    ...mapState("checklist", ["branchs"])
  },
  async mounted() {
    this.getBranch();
  },
  methods: {
    ...mapActions("checklist", ["getBranch"])
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    editEnabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style></style>
